module.exports = __webpack_public_path__ + "img/arrow-r.01cf66b2.svg";